'use strict';

import {gsap} from 'gsap';
import 'scrollTo';
import 'moment';
import select2 from 'select2';

import Loader from '../../../_modules/loader/loader';
import ProductDetails from '../../../_modules/product-details/product-details';
import PoNumber from '../../../_modules/po-number/po-number';
import CarerDetail from '../../../_modules/carer-detail/carer-detail';
import SummaryDashboard from '../../../_modules/summary-dashboard/summary-dashboard';
import FirstOrder  from '../../../_modules/first-order/first-order';
// import OrderOverride  from '../../../_modules/order-override/order-override';

import { debounce, isFieldEmpty, isDobEmpty, isValidEmail, displayErrors, isValidDob, delay, decodeResponse, goToNextSection, displayInputError, adjustFooterOnWindowResize } from './_helper';
import { displayPayContinue } from './_payment';
import { toaster } from './_material';
import { carerDetails, cloneCarerRow, isCarerFormValid } from '../../../_modules/carer-detail/carer-detail';
import SohModalStaffShop from '../../../_modules/soh-modal-staffshop/soh-modal-staffshop';


let $header = $('.header'),
    $dashboard = $('section.view-create-order-abbottadmin'),
    $contactForm = $(".form--contact-details"),
    $productsForm = $(".form--products"),
    $deliveryForm = $(".form--delivery-details"),
    $paymentForm = $(".form--payment"),
    $suggestions = $('.form--suggestions'),
    $institutionId = $('#InstitutionId'),
    $hcpWorkplaceId = $('#HcpWorkplaceId'),
    $title = $('#Title'),
    $firstName = $('#FirstName'),
    $lastName = $('#LastName'),
    $clientId = $('#ClientId'),
    $gst = $('#gst'),
    $deliveryNotes = $('#DeliveryNotes'),
    $primaryNumber = $('#PrimaryNumber'),
    $emailAddress = $('#EmailAddress'),
    $printedVersionSupplied = $("#PrintedVersionSupplied"),
    $clientDetailsConsented = $("#ClientDetailsConsented"),
    $clientLogisticsProviderAgreed = $("#ClientLogisticsProviderAgreed"),
    $clientPersonalDataTransferAgreed = $("#ClientPersonalDataTransferAgreed"),
    $addressLine1 = $('#street_number'),
    $addressLine2 = $('#route'),
    $addressSuburb = $('#locality'),
    $addressPostCode = $('#postal_code'),
    $addressState = $('#administrative_area_level_1'),
    $addressAdditionalNotes = $('#AdditionalAddressNotes'),
    $firstDeliveryCartons = $('#first-delivery__cartons'),
    $firstRowDelivery = $('.form--delivery-details table tr:first-child'),
    $receiptDeliveryFee = $('.receipt--delivery-total'),
    $firstDeliveryFree = $('#FirstDeliveryFree'),
    $allDeliveryFree = $('#FreeDelivery'),
    $createRegimenForm = $('#create-regimen-form'),
    $paymentDelivery = $('#payment-delivery'),
    $counter = $('.counter'),
    $selectCtaPayment,
    formSuggestionTmp = '',
    $regimens = '',
    isCarerPrimaryContact = false,
    isAccountCreated = false,
    isPayNow = true,
    hasCarer = false,
    isAnim = false,
    isSkipStockCheck = false,
    overrideCheckedOrderClicked = false,
    sectionInd = 1,
    obj = {},
    dataParams = {},
    values ={},
    _data = [],
    _filteredData = [],
    _isInvalid = [],
    formSuggestionHtml = '',
    popupInterruptRegimenHtml = '',
    popupInterruptRegimenTmp = '',
    loader,
    $btnClickCollect = $('.js-toggle-click-collect'),
    $btnDeliver = $('.js-toggle-deliver'),
    $panelClickCollect = $(".click-collect"),
    $panelDeliveryAddress = $(".delivery-address"),
    startDate = moment().format('DD-MM-YYYY'),
    $paymentRuleId = $("#PaymentRuleId"),
    $StaffShopConsented = $("#StaffShopConsented"),
    $StaffShopUnderstand  = $("#StaffShopUnderstand"),
    $HCPWorkplaces = $("#HCPWorkplaces"),
    $ContactType = $("#ContactType"),
    $Institution = $("#Institution");

    let showSection = function(section) {
        if(isAnim) return;
        isAnim = true;
        gsap.to(window, {
            duration: 1,
            scrollTo: {
                y: section.offset().top - $header.outerHeight() - parseInt($header.css('top')),
                ease: "expo.inOut"
            },
            onComplete: function () {
                isAnim = false;
            }
        });
    }

$(() => {
    if (!$dashboard.length) {
        return false;
    }

    //init select2 for hcpworkplaces
    $(document).ready(function(e){
        let formatHcp = function (hcp, container) {
            return hcp.text;
        }
    
        let formatHcpSelected = function(hcp, container) {
            return hcp.text;
        }
        $HCPWorkplaces.select2({
            width: "100%",
            allowClear: true,
            placeholder: 'Search a HCP',
            ajax: {
                url: function(params){
                    return `/api/abbotadmins/gethcps`;
                },
                dataType: 'json',
                delay: 250,
                data: function (params) {
                  return {
                    keywords: params.term, // search term
                    page: params.page
                  };
                },
                processResults: function (data, params) {
                  // parse the results into the format expected by Select2
                  // since we are using custom formatting functions we do not need to
                  // alter the remote JSON data, except to indicate that infinite
                  // scrolling can beused
                  params.page = params.page || 1;
                  
                  return {
                    results: data,
                    pagination: {
                      more: (params.page * 30) < data.length
                    }
                  };
                },
                cache: false
              },
              minimumInputLength: 2,
              templateResult: formatHcp,
              templateSelection: formatHcpSelected
          });  
          $HCPWorkplaces.on('select2:select', function (e) {
                let hcpJsonObject = e.params.data;
                $firstName.val(hcpJsonObject.FirstName);
                $lastName.val(hcpJsonObject.LastName);
                $emailAddress.val(hcpJsonObject.Email);
                $Institution.val(hcpJsonObject.Institution);
                $primaryNumber.val(hcpJsonObject.PhoneNumber);
                $clientId.val(hcpJsonObject.ClientId);
                $firstName.trigger("focus");
                $lastName.trigger("focus");
                $emailAddress.trigger("focus");
                $primaryNumber.trigger("focus");
                $Institution.trigger("focus");
            });
    });

    $ContactType.on("change", function(ce){
        let $select = $(this);
        let contactType = $select.val() || "";
        if(contactType != "") {
            $(".contact-details").addClass("show");
            if(contactType == "HCP") {
                $(".hcp-workplaces").show();
            } else {
                $(".hcp-workplaces").hide();
            }
            adjustFooterOnWindowResize();
        }
    })

    // Initialize Products.
    let productDetails = new ProductDetails();
    productDetails.init();

    //Init Summary
    let summaryDetails = new SummaryDashboard();

    // Put Loader in a variable
    loader = new Loader();

    //show contact and products form
    $contactForm.show();
    // $productsForm.show();
    showSection($contactForm);

    // //Init Summary
    // let orderOverrideObj = new OrderOverride();
    // orderOverrideObj.init();

    $btnClickCollect.on('click', function(e){
        e.preventDefault();
        $panelClickCollect.show();
        $panelDeliveryAddress.hide();
        setDeliveryFee();
    });

    $btnDeliver.on('click', function(e){
        e.preventDefault();
        $panelClickCollect.hide();
        $panelDeliveryAddress.show();
        setDeliveryFee();
    })

    // Clear all btn
    $('.js-reset-client-form').on('click', function(e) {
        e.preventDefault();

        let isCreatedRegimen = $('.regime-status').is(':hidden');

        loader = new Loader();

        loader.fadeIn();

        if (isCreatedRegimen) {
            sessionStorage.setItem('isCreateRegimen', 'true');
        }

        setTimeout(function(){ window.location.reload(); }, 250);

    });

    $('.js-jump-section').on('click', function (e) {
        e.preventDefault();

        if (isAnim) {
            return false;
        }

        let $this = $(this),
            $parent = $this.parent(),
            el;

        sectionInd = $parent.index();

        switch (sectionInd) {
            case 1:
                el = $('#patient-details');
                break;
            case 2:
                el = $('#contact-details');
                break;
            case 3:
                el = $('#carer-details');
                break;
            case 4:
                el = $('.form--patient-consent');
                break;
            case 5:
                el = $('#regimen-date');
                break;
            case 6:
                el = $('#regimen-products');
                break;
            case 7:
                el = $('#delivery-details');
                break;
            case 8:
                el = $('#payment-details');
                break;
        }

        gsap.to(window, {
            duration: 1,
            scrollTo: {
                y: el.offset().top - $header.outerHeight() - parseInt($header.css('top')),
                ease: "expo.inOut"
            },
            onComplete: function () {
                isAnim = false;
            }
        });
    });


    $('.js-set-staff-details').on('click', function (e) {
        e.preventDefault();

        if (isAnim) {
            return false;
        }

        _isInvalid = [];

        var phoneRegEx = /^[0-9]{8,10}$/;

        _isInvalid = [];

        if (isFieldEmpty($primaryNumber) || !$primaryNumber.val().match(phoneRegEx)) {
            $primaryNumber
                .parent().addClass('incomplete')
                .find('.error').slideDown({
                duration: 500,
                easing: 'easeOutExpo',
                queue: false
            });

            _isInvalid.push(0);
        }

        if (isFieldEmpty($ContactType)) {
            $ContactType
                .parent().addClass('incomplete')
                .find('.error').slideDown({
                duration: 500,
                easing: 'easeOutExpo',
                queue: false
            });

            _isInvalid.push(0);
        }

        if (isFieldEmpty($firstName)){
            $firstName
                .parent().addClass('incomplete')
                .find('.error').slideDown({
                duration: 500,
                easing: 'easeOutExpo',
                queue: false
            });

            _isInvalid.push(0);
        }
        
        if (isFieldEmpty($Institution)){
            $Institution
                .parent().addClass('incomplete')
                .find('.error').slideDown({
                duration: 500,
                easing: 'easeOutExpo',
                queue: false
            });

            _isInvalid.push(0);
        }
        
        if (isFieldEmpty($lastName)){
            $lastName
                .parent().addClass('incomplete')
                .find('.error').slideDown({
                duration: 500,
                easing: 'easeOutExpo',
                queue: false
            });

            _isInvalid.push(0);
        }

        if (isFieldEmpty($emailAddress) || !isValidEmail($emailAddress.val())) {
            $emailAddress
                .parent().addClass('incomplete')
                .find('.error').slideDown({
                duration: 500,
                easing: 'easeOutExpo',
                queue: false
            });

            _isInvalid.push(0);
        }
        

        if (_isInvalid.length > 0) {
            $(this).addClass('error');
            return false;
        } else {
            _isInvalid = [];

            $(this).removeClass('error');
            toggleProgressBar(4);
            $productsForm.show();
            goToNextSection('#regimen-products');

            // displaySummary('.summary--consent-details');
            return;
        }
    });
    
    //updating Regimen summary start date, when input changes.
    $('.form--start-regimen input').on('change', function () {
        summaryDetails.displaySummary('regimen-date');
    });

    $('.js-confirm-order').on('click', function (e) {
        e.preventDefault();

        let isProductSelected = $('.phase--wrapper.active .product-details__row').length;

        if (isAnim) {
            return false;
        }

        if (!isProductSelected) {
            $(this).addClass('error');
            return false;
        }
        else {
            $(this).removeClass('error');

            toggleProgressBar(6);
            goToNextSection('#delivery-details');
            summaryDetails.displaySummary('regimen-notes');
            summaryDetails.displaySummary('products');

            if($btnDeliver.length == 0) {
                $btnClickCollect.trigger("click");
            }
            if($btnClickCollect.length == 0){
                $btnDeliver.trigger("click");
            }
        }
    });

    $('#regimen-products').on('change', function () {
        summaryDetails.displaySummary('regimen-notes');
        summaryDetails.displaySummary('products');
    });


    $('.js-set-delivery-payment').on('click', function(e) {
        e.preventDefault();

        if (isAnim) {
            return false;
        }

        _isInvalid = [];

        if (isFieldEmpty($addressLine1)) {
            $addressLine1
                .parent().addClass('incomplete')
                .find('.error').slideDown({
                duration: 500,
                easing: 'easeOutExpo',
                queue: false
            });

            _isInvalid.push(0);
        }

        if (isFieldEmpty($addressPostCode)) {
            $addressPostCode
                .parent().addClass('incomplete')
                .find('.error').slideDown({
                duration: 500,
                easing: 'easeOutExpo',
                queue: false
            });

            _isInvalid.push(0);
        }

        if (isFieldEmpty($addressSuburb)) {
            $addressSuburb
                .parent().addClass('incomplete')
                .find('.error').slideDown({
                duration: 500,
                easing: 'easeOutExpo',
                queue: false
            });

            _isInvalid.push(0);
        }

        if (isFieldEmpty($addressState)) {
            $addressState
                .parent().addClass('incomplete')
                .find('.error').slideDown({
                duration: 500,
                easing: 'easeOutExpo',
                queue: false
            });

            _isInvalid.push(0);
        }

        if (_isInvalid.length > 0) {
            $('#delivery-details').addClass('error');
            return false;
        } else {
            _isInvalid = [];

            // If there is only 1 payment option, make it selected by default.
            if ($('.payment__list li').length === 1) {
                $('.payment__list li').addClass('selected');
                $('.payment__list li button')
                    .addClass('active')
                    .trigger('click');
            }

            $('#delivery-details').removeClass('error');
            $('#delivery-details').addClass('completed');

            toggleProgressBar(7);
            goToNextSection('#payment-details');

            // displaySummary('.summary--delivery-details');
            // displayDeliverySummary();

            var $js_display_summary  = $('.js-display-summary'),
                $summary = $('.summary-dashboard'),
                $label = $('.show-summary__link-label');

            $js_display_summary.toggleClass('active');

            if ($js_display_summary.is('.active')) {
                $label.text('Hide summary');
            } else {
                $label.text('Show summary');
            }

            $summary.slideToggle();
        }
    });


    $('.js-set-delivery').on('click', function(e) {
        e.preventDefault();

        if (isAnim) {
            return false;
        }

        _isInvalid = [];

        let isDelivery = true;//$btnDeliver.is(".active");
        // if(!$btnClickCollect.is(".active") && !$btnDeliver.is(".active")){
        //     _isInvalid.push(0);
        // }

        if(isDelivery){
            if (isFieldEmpty($addressLine1)) {
                $addressLine1
                    .parent().addClass('incomplete')
                    .find('.error').slideDown({
                    duration: 500,
                    easing: 'easeOutExpo',
                    queue: false
                });

                _isInvalid.push(0);
            }

            if (isFieldEmpty($addressPostCode)) {
                $addressPostCode
                    .parent().addClass('incomplete')
                    .find('.error').slideDown({
                    duration: 500,
                    easing: 'easeOutExpo',
                    queue: false
                });

                _isInvalid.push(0);
            }

            if (isFieldEmpty($addressSuburb)) {
                $addressSuburb
                    .parent().addClass('incomplete')
                    .find('.error').slideDown({
                    duration: 500,
                    easing: 'easeOutExpo',
                    queue: false
                });

                _isInvalid.push(0);
            }

            if (isFieldEmpty($addressState)) {
                $addressState
                    .parent().addClass('incomplete')
                    .find('.error').slideDown({
                    duration: 500,
                    easing: 'easeOutExpo',
                    queue: false
                });

                _isInvalid.push(0);
            }
        }

        if (_isInvalid.length > 0) {
            $(this).addClass('error');
            return false;
        } else {
            _isInvalid = [];

            // If there is only 1 payment option, make it selected by default.
            if ($('.payment__list li').length === 1) {
                $('.payment__list li').addClass('selected');
                $('.payment__list li button')
                    .addClass('active')
                    .trigger('click');
            }

            $(this).removeClass('error');
            $('#delivery-details').addClass('completed');

            toggleProgressBar(7);
            goToNextSection('#payment-details');

            summaryDetails.displaySummary('delivery');
            //productDetails.getAllProducts(true);
        }
    });

    $('.form--delivery-details input').on('blur', function () {
        summaryDetails.displaySummary('delivery');
    });

    //TODO refactor: this should have been removed, check why still here
    let displayDeliverySummary = function (){

        values = {
            "DeliveryNotes" : $('#DeliveryNotes option:selected').text(),
            "AddressLine1" : $addressLine1.val(),
            "AddressLine2" : $addressLine2.val(),
            "AddressPostCode" : $addressPostCode.val(),
            "AddressSuburb" : $addressSuburb.val(),
            "AddressState" : $addressState.val()
        };
    }

    let displayContactSummary = function() {
        values = {
            'PhoneNumber': $primaryNumber.val(),
            'SecondaryNumber': $secondaryNumber.val() == '' ? null : $secondaryNumber.val(),
            'EmailAddress': $emailAddress.val() == '' ? null : $emailAddress.val(),
            'Carer': carerDetails()
        };
    };

    //Update summary if changes occur after completing each form
    //also need a displayDeliveryNotesSummary
    $('body').on('change', '#contact-details.completed input', function(){
        displayContactSummary();
    });

    $('body').on('change', '#delivery-details.completed input', function(){
        displayDeliverySummary();
    });

    $('body').on('change', $addressState, function(e){
        e.stopImmediatePropagation();

        setDeliveryFee();
    });

    $('body').on('change', $firstDeliveryCartons, function(e){
        e.stopImmediatePropagation();

        setDeliveryFee();
    });

    //TODO: when time, consider reviewing all the following CTA
    // eg js-pay-now and js-pay-continue could be consolidated
    // the only difference is the function they perform, if successful

    $('.js-pay-now').on('click', function (e) {
        e.preventDefault();

        if(!isPaymentSelected($(this)))
            return false;

        isPayNow = true;
        $selectCtaPayment = $(this);
        $selectCtaPayment.hide();

        isSkipStockCheck = true;
        let soh = new SohModalStaffShop();
        $.when(
            soh._isInStock()
        ).then(function(data){
            if(data.IsInStock) {
                setRegimenValues(isPayNow, $(this));
            } else {
                $selectCtaPayment.show();
            }
        });
    });

    $('.js-ignore-soh').on('click', function (e) {
        e.preventDefault();

        //TODO make reusable (for each submission button on creating regimen)
        if($(this).hasClass('disabled'))
          return false;

        $(this).addClass('disabled');

        $.fancybox.close();

        isPayNow = true;
        isSkipStockCheck = true;
        setRegimenValues(isPayNow, $(this));
    });
});

/* Prepare values to send when calling the API. Notes:
** - $isFirstFree: if not in the markup, send "false" value instead of null
** - stock will be checked only it is Pay Now
*/
let setRegimenValues = function(isPayNow, clickedButton){
    let $dieticiansPatientNotes = $('#DieticiansPatientNotes'),
        $hcpNotes = $('#HcpNotes'),
        $hcpCsNotes = $('#HcpCsNotes'),
        $csNotes = $('#CsNotes'),
        $poNumberList = $('.PoNumber__list'),
        $poContainer = $('.po-number__container'),
        $customPoNumber = $('#CustomPoNumber'),
        $isFirstFree = $('#IsFirstOrderFree'),
        // Define where to display ajax errors
        $errorContainer = $('.js-error--set-regimen'),
        institutionIdVal = '',
        hcpWorkplaceVal = '',
        firstorder,
        hcpId = '';

    let productDetails = new ProductDetails(),
        isOrderOverriden = $('.form--order-override').is(':visible'),
        overrideorder;

    if(isOrderOverriden)
        firstorder = new FirstOrder();

    // Purchase Order Number is mandatory only if payment option is either "Institution Pays" or "Co-pays"
    if ($poContainer.is(':visible')){

        // values from the list
        if(isFieldEmpty($poNumberList)){
            displayInputError($poNumberList, false);
            clickedButton.removeClass('disabled');
            return false;
        }
    }
    let poNumber = new PoNumber();

    if(!poNumber.isValidPONumber('newRegimen')){
      clickedButton.removeClass('disabled');
      return false;
    }

    loader.fadeIn();

    institutionIdVal = $institutionId.val();
    hcpWorkplaceVal = $hcpWorkplaceId.val();
    hcpId = $HCPWorkplaces.val();

    dataParams = {
        "InstitutionId" : institutionIdVal,
        "HcpWorkplaceId" : hcpWorkplaceVal,
        "HcpId": hcpId,
        "Client": {
            'Carers': null,
            "Details": {
                'Title' : $title.val() == "" ? "Mr" : $title.val(),
                'FirstName': $firstName.val(),
                'LastName': $lastName.val(),
                'Dob' : {
                    'Day' : 1,
                    'Month' : 1,
                    'Year' : 2000
                },
                'Gender': 0,
                'ClientUr': null,
                'PrimaryPhoneNumber': $primaryNumber.val(),
                'SecondaryPhoneNumber': null,
                'EmailAddress': $emailAddress.val() == '' ? null : $emailAddress.val(),
                'NDISEligibility': "No"
            },
            'IsDoNotCallOpted': !$StaffShopConsented.prop("checked"),
            "AgreesToPrivacy": true,
            "DoesClientHaveCarer": false,
            "InstitutionId": $institutionId.val(),
            "ClientId": $clientId.val(),
            "Address": {
                "Address1" : $addressLine1.val(),
                "Address2" : $addressLine2.val(),
                "Suburb" : $addressSuburb.val(),
                "PostCode" : $addressPostCode.val(),
                "State" : $addressState.val() == '' ? 'NSW' : $addressState.val(),
                "AdditionalNote": (isFieldEmpty($addressAdditionalNotes) ? "" : $addressAdditionalNotes.val()) + " " + $Institution.val()
            }
        },
        "RegimenNotes": {
            "DieticiansClientNotes" : $ContactType.val(),
            "HcpNote": isFieldEmpty($hcpNotes) ? null : $hcpNotes.val(),
            "HcpAndCustomerSupportNote": $Institution.val(),
            "CustomerSupportNote": $HCPWorkplaces.val()
        },
        "Phases": productDetails.getSelectedProducts(),
        "DeliveryNoteId" : isFieldEmpty($deliveryNotes) ? null : $deliveryNotes.val(),
        "PaymentRuleId": $paymentRuleId.val(),
        "IsPayNow" : isPayNow,
        "PurchaseOrderNumber" : $poNumberList.val() == '' ? null : poNumber.getPONumber('newRegimen'),
        "DeliveryFeeType": setDeliveryFeeType(),
        "IsUrgentOrder": false,
        "CanStartImmediately": true,
        "StartDate": startDate,
        "RequiresHcpApproval": false,
        "IsFirstOrderFree": true,
        "AreAllOrdersFree": false,
        "DisableClientNotifications": true,
        "FirstOrderOverride": null,
        "SkipStockCheck": isSkipStockCheck
    };
    if(dataParams.DeliveryFeeType == 3) {
        //if address is not populated, put in default values to bypass val
        let addr = dataParams.Client.Address;
        if(addr.Address1 == "") {
            addr.Address1 = " - ";
        }
        if(addr.Suburb == "") {
            addr.Suburb = " - ";
        }
        if(addr.PostCode == "") {
            addr.PostCode = "200";
        }
    }
    dataParams.Phases.forEach(phObj => {
        phObj.NumberOfOrders = 1;
    });

    $.ajax({
        url: '/api/regimens',
        dataType: 'json',
        contentType: 'application/json; charset=utf-8',
        // Comment out for simulation.
        type: 'POST',
        headers: { __RequestVerificationToken: $createRegimenForm.find('input[name=__RequestVerificationToken]').val() },
        data: JSON.stringify(dataParams),
        success: function (data) {
            toaster('Nutrition plan saved successfully. Redirecting.');

            $errorContainer.slideUp({
                duration: 500,
                easing: 'easeInOutExpo',
                queue: false
            });

            window.location.href = data.href;

            loader.fadeOut();
        },
        error: function (error) {
            loader.fadeOut();
            displayErrors(error, $errorContainer );
            clickedButton.removeClass('disabled');
            if(overrideCheckedOrderClicked){
              $('.js-override-checked-order').removeClass('disabled');
              overrideCheckedOrderClicked = false;
            }
        }
    });
};

let setDeliveryFee = function(){
    let $deliverFee = $('.delivery-fee'),
        cartonsFirstOrder = $firstDeliveryCartons.val(),
        isFreeDelivery = false,
        state = $addressState.val(),
        gst = $gst.val(),
        oneCartonCost = 0,
        twoCartonCost = 0,
        moreCartonCost = 0,
        fee = 0.0,
        adminFeeInCents = parseFloat($('#AdministrationFee').val()),
        deliveryGst,
        deliveryGstIncluded,
        totalGst,
        total = $('.phase--wrapper.active .product-details:first-child .regimen-total__price').text(),
        el,
        productDetails = new ProductDetails(),
        prodGst = productDetails.calculateTotalGst(),
        $DeliveryFee = $("#DeliveryFee").val(),
        clickCollectFee = $panelClickCollect.find(".radio-button input[checked]").data("cost"),
        isClickCollect = $btnClickCollect.is(".active");

        if(isClickCollect && clickCollectFee == 0) {
            isFreeDelivery = true;
        }

    switch (state) {
        case 'ACT':
            el = $('#delivery-costs--ACT');
            break;
        case 'NSW':
            el = $('#delivery-costs--NSW');
            break;
        case 'NT':
            el = $('#delivery-costs--NT');
            break;
        case 'QLD':
            el = $('#delivery-costs--QLD');
            break;
        case 'SA':
            el = $('#delivery-costs--SA');
            break;
        case 'TAS':
            el = $('#delivery-costs--TAS');
            break;
        case 'VIC':
            el = $('#delivery-costs--VIC');
            break;
        case 'WA':
            el = $('#delivery-costs--WA');
            break;
        default:
            el = $('#delivery-costs--NSW');
            break;
    }

    if(isFreeDelivery) {
        $deliverFee.text('0');
        $firstRowDelivery.show();
        deliveryGst = 0;
        deliveryGstIncluded = 0;
    } else {
        if(isClickCollect) {
            fee == clickCollectFee;
        } else {
            if(el.length > 0) {
                oneCartonCost = el.data('one-carton');
                twoCartonCost = el.data('two-carton');
                moreCartonCost = el.data('more-carton');
            }
            if (cartonsFirstOrder == 0) {
                fee = 0;
            } else if (cartonsFirstOrder == 1) {
                fee = oneCartonCost;
            }
            else if (cartonsFirstOrder == 2) {
                fee = twoCartonCost;
            } else{
                fee = moreCartonCost ;
            }
        }
        // Fees are in cents --> need to convert into dollars
        fee = fee * .01;
        deliveryGst = fee * gst;
        deliveryGstIncluded = (fee + deliveryGst).toFixed(2);
    }

    totalGst = (prodGst + deliveryGst + adminFeeInCents * 0.01 * gst).toFixed(2);

    // set delivery fee
    $deliverFee.text(deliveryGstIncluded);
    $receiptDeliveryFee.text(deliveryGstIncluded);

    $paymentDelivery.val(deliveryGstIncluded);

    //set total GST Amount
    $('.receipt--gst-total').text(totalGst);

    // review total in the payment summary
    total = Number(total) + Number(deliveryGstIncluded);
    total = total.toFixed(2);
    $('.form--payment .summary .num').text(total);
    $('.show-summary__tot').text(total);
};

// Toggle progress bar, different from the one in the helpers
function toggleProgressBar(sectionInd) {
    if (!hasCarer && sectionInd == 2) {
        sectionInd = sectionInd + 1;
    }

    if (sectionInd > 1) {
        $('.show-summary__link').show();
    }

    if (sectionInd > 5) {
        $('.show-summary__link .odo').show();
        $('.summary-dashboard--right').show();
    } else {
        $('.show-summary__link .odo').hide();
        $('.summary-dashboard--right').hide();
    }

    // $multiStepsNav.find('li:nth-child(' + sectionInd + ')')
    //     .removeClass('active')
    //     .next().addClass('current-page__link active');
};

let isPaymentSelected = function($button){
    return true;
};

/*  always check SOH, unless
**  - it is pay later
**  - it needs HPC approval
**  - it starts later */
let isStockToReview = function(){
    return true;
};

// Populate the form details
let populateDetails = function (ind) {

    if (_data[ind].Details.Title != null) {
        $title
            .val(_data[ind].Details.Title).change()
            .addClass('readonly')
            .attr('disabled', true)
            .parent()
            .removeClass('incomplete')
            .addClass('complete focus')
            .find('.error').fadeOut({
            duration: 500,
            easing: 'easeOutExpo',
            queue: false
        });
    }

    if (_data[ind].Details.FirstName != null) {
        $firstName
            .val(decodeResponse(_data[ind].Details.FirstName))
            .prop('readonly', true)
            .parent()
            .removeClass('incomplete')
            .addClass('readonly')
            .find('.error').fadeOut({
            duration: 500,
            easing: 'easeOutExpo',
            queue: false
        });
    }

    if (_data[ind].Details.LastName != null) {
        $lastName
            .val(decodeResponse(_data[ind].Details.LastName))
            .prop('readonly', true)
            .parent()
            .removeClass('incomplete')
            .addClass('readonly')
            .addClass('complete focus')
            .find('.error').fadeOut({
            duration: 500,
            easing: 'easeOutExpo',
            queue: false
        });
    }

    if (_data[ind].Details.Dob.Day != null || _data[ind].Details.Dob.Month != null || _data[ind].Details.Dob.Year != null) {
        $dobDay
            .val(decodeResponse(_data[ind].Details.Dob.Day))
            .prop('readonly', true)
            .parent()
            .removeClass('incomplete')
            .addClass('readonly')
            .addClass('complete focus');

        $('.dob .error').fadeOut({
            duration: 500,
            easing: 'easeOutExpo',
            queue: false
        });

        $dobMonth
            .val(decodeResponse(_data[ind].Details.Dob.Month))
            .prop('readonly', true)
            .parent()
            .removeClass('incomplete')
            .addClass('readonly')
            .addClass('complete focus')
            .find('.error').fadeOut({
            duration: 500,
            easing: 'easeOutExpo',
            queue: false
        });

        $dobYear
            .val(decodeResponse(_data[ind].Details.Dob.Year))
            .prop('readonly', true)
            .parent()
            .removeClass('incomplete')
            .addClass('complete focus')
            .addClass('readonly')
            .find('.error').fadeOut({
            duration: 500,
            easing: 'easeOutExpo',
            queue: false
        });
    }

    if (_data[ind].Details.Gender != null) {
        $gender
            .val(_data[ind].Details.Gender).change()
            .addClass('readonly')
            .attr('disabled', true)
            .parent()
            .removeClass('incomplete')
            .addClass('complete focus')
            .find('.error').fadeOut({
            duration: 500,
            easing: 'easeOutExpo',
            queue: false
        });
    }

    if (_data[ind].Id != null) {
        $clientId
            .val(decodeResponse(_data[ind].Id));
    }

    if (_data[ind].IsEligibleForFreeDelivery != null) {
        $isEligibleForFreeDelivery
            .val(_data[ind].IsEligibleForFreeDelivery)
            .trigger('change');
    }

    if (_data[ind].Carers != null && _data[ind].Carers.length != 0) {
        hasCarer = true;

        $patientHaveCarer
            .prop('checked', true)
            .parent().addClass('checked');

        $primaryContact.parent().show();

    } else {
        $patientHaveCarer
            .prop('checked', false)
            .parent().removeClass('checked');

        $('.form--carer-details').hide();
    }

    if (_data[ind].Details.IsDoNotCallOpted == true) {

        $doNotCall
            .prop('checked', true)
            .parent().addClass('checked');

    } else {
        $doNotCall
            .prop('checked', false)
            .parent().removeClass('checked');
    }

    if (_data[ind].Details.PrimaryPhoneNumber != null) {
        $primaryNumber
            .val(decodeResponse(_data[ind].Details.PrimaryPhoneNumber))
            .parent()
            .addClass('complete focus');
    }

    if (_data[ind].Details.SecondaryPhoneNumber != null) {
        $secondaryNumber
            .val(decodeResponse(_data[ind].Details.SecondaryPhoneNumber))
            .parent()
            .addClass('complete focus');
    }

    if (_data[ind].Details.ClientUr != null) {
        $clientUR
            .val(decodeResponse(_data[ind].Details.ClientUr))
            .parent()
            .addClass('complete focus');
    }

    if (_data[ind].Details.EmailAddress != null) {
        $emailAddress
            .val(decodeResponse(_data[ind].Details.EmailAddress))
            .parent()
            .addClass('complete focus');
    }

    if (_data[ind].Carers != null) {

        var _carersList = _data[ind].Carers,
            numberOfCarers =  _carersList.length;

        while(numberOfCarers > 1){
            cloneCarerRow();
            numberOfCarers--;
        }

        $.each(_carersList, function(index, carer){

            let $curretRow = $('.carer-details__row').eq(index);

            $curretRow
                .find('.js-remove-carer')
                .remove();

			$curretRow
                .find('.CarerId')
                .val(decodeResponse(carer.Id));

            $curretRow
                .find('.CarerFirstName')
                .val(decodeResponse(carer.FirstName))
                .parent()
                .addClass('complete focus');

            $curretRow
                .find('.CarerLastName')
                .val(decodeResponse(carer.LastName))
                .parent()
                .addClass('complete focus');

            if (carer.PrimaryPhoneNumber != null) {
                $curretRow
                    .find('.CarerPrimaryNumber')
                    .val(decodeResponse(carer.PrimaryPhoneNumber))
                    .parent()
                    .addClass('complete focus');
            }

            if (carer.SecondaryPhoneNumber != null) {
                $curretRow
                    .find('.CarerSecondaryNumber')
                    .val(decodeResponse(carer.SecondaryPhoneNumber))
                    .parent()
                    .addClass('complete focus');
            }

            if (carer.EmailAddress != null) {
                $curretRow
                    .find('.CarerEmailAddress')
                    .val(decodeResponse(carer.EmailAddress))
                    .parent()
                    .addClass('complete focus');
            }

			if (carer.RelationshipToClient != null) {
                $curretRow
                    .find('.CarerRelationshipToClient')
                    .val(carer.RelationshipToClient).change()
                    .parent()
                    .addClass('complete focus');
            }

            if (carer.PrimaryContact === true) {
                isCarerPrimaryContact = true;

                $primaryContact
                    .prop('checked', true)
                    .trigger('change')
                    .parent().addClass('checked');
            }
        });
    }

    if (_data[ind].Address.Address1 != null) {
        $addressLine1
            .val(decodeResponse(_data[ind].Address.Address1))
            .parent()
            .removeClass('incomplete')
            .addClass('complete focus')
            .find('.error').fadeOut({
            duration: 500,
            easing: 'easeOutExpo',
            queue: false
        });
    }

    if (_data[ind].Address.Address2 != null) {
        $addressLine2
            .val(decodeResponse(_data[ind].Address.Address2))
            .parent()
            .removeClass('incomplete')
            .addClass('complete focus')
            .find('.error').fadeOut({
            duration: 500,
            easing: 'easeOutExpo',
            queue: false
        });
    }

    if (_data[ind].Address.Suburb != null) {
        $addressSuburb
            .val(decodeResponse(_data[ind].Address.Suburb))
            .parent()
            .removeClass('incomplete')
            .addClass('complete focus')
            .find('.error').fadeOut({
            duration: 500,
            easing: 'easeOutExpo',
            queue: false
        });
    }

    if (_data[ind].Address.Postcode != null) {
        $addressPostCode
            .val(decodeResponse(_data[ind].Address.Postcode))
            .parent()
            .removeClass('incomplete')
            .addClass('complete focus')
            .find('.error').fadeOut({
            duration: 500,
            easing: 'easeOutExpo',
            queue: false
        });
    }

    if (_data[ind].Address.State != null) {
        $addressState
            .val(_data[ind].Address.State)
            .parent()
            .removeClass('incomplete')
            .addClass('complete focus')
            .find('.error').fadeOut({
            duration: 500,
            easing: 'easeOutExpo',
            queue: false
        });
    }

    if (_data[ind].Address.AdditionalNote != null) {
        $addressAdditionalNotes
            .val(_data[ind].Address.AdditionalNote)
            .parent()
            .removeClass('incomplete')
            .addClass('complete focus')
            .find('.error').fadeOut({
            duration: 500,
            easing: 'easeOutExpo',
            queue: false
        });
    }
};

// Reset form
function resetForm() {
    sectionInd = 1;
    isAnim = true;
    isCarerPrimaryContact = false;
    isAccountCreated = false;
    hasCarer = false;

    gsap.to(window, {duration: 1,
        scrollTo: {
            y: 0,
            ease: "expo.inOut"
        },
        onComplete: function () {
            isAnim = false;
        }
    });

    $multiStepsNav
        .find('.current-page__link')
        .removeClass('current-page__link')
        .end()
        .find('.back-to')
        .next().addClass('current-page__link');

    $suggestions.removeClass('active');

    $patientHaveCarer.prop('checked', false)
        .parent().removeClass('checked');

    //TODO: loop instead of repeating?!
    $firstName
        .val('')
        .parent().removeClass('complete focus');

    $lastName
        .val('')
        .parent().removeClass('complete focus');

    $dobDay
        .val('')
        .parent().removeClass('complete focus');

    $dobMonth
        .val('')
        .parent().removeClass('complete focus');

    $dobYear
        .val('')
        .parent().removeClass('complete focus');

    $gender
        .val('')
        .parent().removeClass('complete focus');

    $clientId
        .val('')
        .parent().removeClass('complete focus');

    $deliveryNotes
        .val('')
        .parent().removeClass('complete focus');

    $primaryContact
        .val('')
        .parent().removeClass('complete focus');

    $primaryNumber
        .val('')
        .parent().removeClass('complete focus');

    $secondaryNumber
        .val('')
        .parent().removeClass('complete focus');

    $emailAddress
        .val('')
        .parent().removeClass('complete focus');

    $patientHaveCarer
        .val('')
        .parent().removeClass('complete focus');

    $carerFirstName
        .val('')
        .parent().removeClass('complete focus');

    $carerLastName
        .val('')
        .parent().removeClass('complete focus');

    $carerPrimaryNumber
        .val('')
        .parent().removeClass('complete focus');

    $carerSecondaryNumber
        .val('')
        .parent().removeClass('complete focus');

    $carerEmailAddress
        .val('')
        .parent().removeClass('complete focus');

    $carerRelationshipToClient
        .val('')
        .parent.removeClass('complete focus');

    $addressLine1
        .val('')
        .parent().removeClass('complete focus');

    $addressLine2
        .val('')
        .parent().removeClass('complete focus');

    $addressSuburb
        .val('')
        .parent().removeClass('complete focus');

    $addressPostCode
        .val('')
        .parent().removeClass('complete focus');

    $addressState
        .val('')
        .parent().removeClass('complete focus');

    $('.form--patient-details, .form--contact-details, .form--carer-details, .form--patient-consent').fadeOut({
        duration: 500,
        easing: 'easeOutExpo',
        queue: false,
        complete: function () {
            $('.regime-status').fadeIn({
                duration: 500,
                easing: 'easeOutExpo',
                queue: false
            });
        }
    });
};

let setDeliveryFeeType = function() {
    let type = 0;
    if($btnClickCollect.is(".active")) {
        type = 3;
    }
    return type;
};

export { resetForm, setDeliveryFee};
